import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useNavigate } from 'react-router';
import KeszletinformacioLista from './KeszletinformacioLista.js';
import KeszletszintLista from './KeszletszintLista.js';
import ErtesitesLista from './ErtesitesLista.js';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip.js';
import getTooltip from './KeszletszintTooltips.js';

export default function WithNav(props) {
  return <KeszletinformacioBase {...props} navigate={useNavigate()} />
}

const KeszletinformacioBase = (props) => {
  const { globals } = props;

  const [activeTab, setActiveTab] = useState('1');

  const page = globals.useQuery().get("page");

  const defaultRoles = [
    {
      rolename: 'KESZLETNYILV_KESZLETINFO',
      tab: '1',
      spec: false
    },
    {
      rolename: 'KESZLETNYILV_KESZLETSZINT',
      tab: '2',
      spec: false
    },
    {
      rolename: 'KESZLETNYILV_KESZLETSZINT',
      tab: '3',
      spec: false
    },
  ];

  /** Lefut, amikor a komponens betöltődik. */
  useEffect(() => {
    if (page)
      toggle(page);
    else
      globals.setDefaultActiveTab(defaultRoles, toggle);
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  let cardStyle = {
    padding: 10
  };

  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Készletinformáció
          </div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <Nav tabs>
                {
                  globals.hasRole(['KESZLETNYILV_KESZLETINFO']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '1' })} onClick={() => { toggle('1'); }}>
                      Készletinformáció
                    </NavLink>
                  </NavItem>
                  )
                }
                {
                  globals.hasRole(['KESZLETNYILV_KESZLETSZINT']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '2' })} onClick={() => { toggle('2'); }}>
                      Készletszint figyelés
                    </NavLink>
                  </NavItem>
                  )
                }
                {
                  globals.hasRole(['KESZLETNYILV_KESZLETSZINT']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '3' })} onClick={() => { toggle('3'); }}>
                      Értesítés <CustomTooltip text={getTooltip('ertesites')} id="ertesitesTT" />
                    </NavLink>
                  </NavItem>
                  )
                }
              </Nav>
              <TabContent activeTab={activeTab}>
                {globals.hasRole(['KESZLETNYILV_KESZLETINFO']) && (
                  <TabPane tabId="1">
                    <KeszletinformacioLista {...props} globals={globals} />
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_KESZLETSZINT']) && (
                  <TabPane tabId="2">
                    <KeszletszintLista {...props} globals={globals} />
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_KESZLETSZINT']) && (
                  <TabPane tabId="3">
                    <ErtesitesLista {...props} globals={globals} /> 
                  </TabPane>
                )}
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
